/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Risks_TitleInputs */

const en_home_risks_title = /** @type {(inputs: Home_Risks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We risk <u>losing control</u>`)
};

/**
* | output |
* | --- |
* | "We risk <u>losing control</u>" |
*
* @param {Home_Risks_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_risks_title = /** @type {((inputs?: Home_Risks_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Risks_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_risks_title(inputs)
});